import { BlogPage } from '@/blog/domain/BlogPage';
import { BlogResponse, PostResponse } from '@/blog/domain/BlogResponse';
import { Post } from '@/blog/domain/Post';
import { PostRepository } from '@/blog/domain/PostRepository';
import { PostFilters } from '@/blog/infrastructure/types/PostFilters';
import { ServicesApiResponse } from '@hfc/ui-core';

export class PostMemory implements PostRepository {

  public async getFeaturedPost (): Promise<Post> {
    await this.sleep(3000);

    const postResponse: PostResponse = {
      author: {
        id: 1,
        name: 'Health for California',
      },
      title: 'Did You Know Some Health Care Costs Are Tax-Deductible',
      content: 'If your insurance doesn’t fully cover your medical bills, you may be able to use them to reduce your tax bill. Only some medical costs are tax-deductible, so it’s important to…',
      thumbnail: 'image.png',
      date: 1678994399980,
      slug: 'slug',
    };

    return new Post(postResponse);
  }

  public async getBlogPage (filters: PostFilters): Promise<ServicesApiResponse<BlogPage>> {
    const postResponses: Array<PostResponse> = [
      {
        title: 'Did You Know Some Health Care Costs Are Tax-Deductible',
        author: {
          id: 1,
          name: 'Health for California',
        },
        content: 'If your insurance doesn’t fully cover your medical bills, you may be able to use them to reduce your tax bill. Only some medical costs are tax-deductible, so it’s important to…',
        slug: 'slug',
        thumbnail: 'image.png',
        date: 1678994399980,
      },
      {
        title: 'How Preventive Care Can Save You Money at Tax Time',
        content: 'Routine checkups and screenings may qualify for potential tax advantages. Understanding which costs count can help you…',
        slug: 'preventive-care-tax-savings',
        author: {
          id: 1,
          name: 'Health for California'
        },
        thumbnail: 'image.png',
        date: 1678994400001,
      },
      {
        title: 'Unexpected Medical Bills? You Might Get Tax Relief',
        content: 'Many taxpayers overlook deductions tied to surprise medical expenses. Here’s what you should know before filing…',
        slug: 'unexpected-medical-bills-tax-relief',
        author: {
          id: 1,
          name: 'Health for California'
        },
        thumbnail: 'image.png',
        date: 1678994400002,
      },
      {
        title: 'Which Medical Expenses Actually Qualify for Deductions?',
        content: 'Not all health care costs are treated equally by tax laws. Learn which ones can reduce what you owe…',
        slug: 'qualifying-medical-expenses',
        author: {
          id: 1,
          name: 'Health for California'
        },
        thumbnail: 'image.png',
        date: 1678994400003,
      },
      {
        title: 'How to Track Deductible Medical Costs Throughout the Year',
        content: 'A little organization can mean big savings. Keeping good records ensures you don’t miss valuable deductions…',
        slug: 'track-deductible-costs',
        author: {
          id: 1,
          name: 'Health for California'
        },
        thumbnail: 'image.png',
        date: 1678994400004,
      },
      {
        title: 'Don’t Miss These Commonly Overlooked Medical Deductions',
        content: 'From transportation to certain treatments, some deductible costs often slip through the cracks. Make sure you’re aware of…',
        slug: 'overlooked-medical-deductions',
        author: {
          id: 1,
          name: 'Health for California'
        },
        thumbnail: 'image.png',
        date: 1678994400005,
      }
    ];
    const postCollectionFiltered = postResponses.filter(post => filters.search ? post.title.toLowerCase().includes(filters.search.toLowerCase()) : true);

    const blogPageResponse: BlogResponse = {
      headTitle: 'Blog',
      pageInfo: {
        description: 'Blog',
        title: 'HFC Blog'
      },
      filters: {
        categories: [
          {
            key: 'health',
            value: 'Health'
          },
          {
            key: 'tax',
            value: 'Tax'
          },
          {
            key: 'insurance',
            value: 'Insurance'
          }
        ]
      },
      posts: postCollectionFiltered,
      metaTags: [],
      totalPosts: postCollectionFiltered.length,
    };
    await this.sleep(1000);

    return {
      success: true,
      data: new BlogPage(blogPageResponse)
    };
  }

  private sleep (ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}
